import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MesCusto } from '../../shared/model/relatorio-custo.models';

@Component({
  selector: 'app-meses-lista',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './meses-lista.component.html',
  styleUrls: ['./meses-lista.component.css'],
})
export class MesesListaComponent {
  @Input({ required: true }) meses!: MesCusto[];
  @Input() mesSelecionado: number | null = null;

  @Output() mesSelect = new EventEmitter<number | null>();

  select(mes: number) {
    if (this.mesSelecionado === mes) {
      this.mesSelect.emit(null);
      return;
    }
    this.mesSelect.emit(mes);
  }

  formatUSD(value: number) {
    return (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
}
